__turbopack_context__.v({
  "inverted": "EFnD0q_inverted",
  "teaser": "EFnD0q_teaser",
  "teaserdisclaimer": "EFnD0q_teaserdisclaimer",
  "teaserimage": "EFnD0q_teaserimage",
  "teaserlinks": "EFnD0q_teaserlinks",
  "teaserparagraph": "EFnD0q_teaserparagraph",
  "teasertext": "EFnD0q_teasertext",
});
